/**
 * Keycode mapping.
 * @type {Object}
 */
export const KEYCODES = {
    ESCAPE: 27,
};
